import { render, staticRenderFns } from "./ResetPasswordWithMobileNumber.vue?vue&type=template&id=71ca76d8"
import script from "./ResetPasswordWithMobileNumber.vue?vue&type=script&lang=js"
export * from "./ResetPasswordWithMobileNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports